// extracted by mini-css-extract-plugin
module.exports = {"number":"cat-count-module--number--10WJ4"};